import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n/config'; // Initialize i18n
import { loadProfessionsFromLocalStorage } from '@/services/professions/getProfessionsNew';

// Load professions from localStorage SYNC before React renders
// This ensures instant profession labels on returning visits
loadProfessionsFromLocalStorage();

const rootElement = document.getElementById("root");

if (rootElement) {
  // Remove the loading shell
  const win = window as Window & { __removeShell?: () => void };
  if (typeof win.__removeShell === 'function') {
    win.__removeShell();
  }
  
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}
